import { useBunja } from 'bunja/react';

import { TradingLeaderboardTier } from '@flipster/apis/v2/trading-leaderboards/types';
import { useRouter } from '@flipster/i18n/routing';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { TradingLeaderboardEvent } from '@flipster/utils/segment/events/trading-leaderboard';

import { SegmentPage } from '../../../../misc/segment/segment-page';
import { tierInfos } from '../../../../trading-leaderboard-page/shared/constants';
import { entryPopupBlockBunja, entryPopupItemBunja } from '../../bunja';
import Shark from './assets/shark.svg';
import Starter from './assets/starter.svg';
import Whale from './assets/whale.svg';

const TierIcon = ({ tier }: { tier: TradingLeaderboardTier }) => {
  if (tier == 'ALL') return null;
  const Icon = {
    STARTER: Starter,
    WHALE: Whale,
    SHARK: Shark,
  }[tier];
  return <Icon width={120} height={120} />;
};

export const LeagueMainOnboardingModal = () => {
  const router = useRouter();
  const { popup, onClose } = useBunja(entryPopupItemBunja);
  const { block } = useBunja(entryPopupBlockBunja);

  if (popup.id !== 'WELCOME_TO_TIERED_LEAGUE') throw new Error('Popup ID mismatch');
  const tier = popup.data.tier;
  const { label: tierLabel } = tierInfos[tier];
  return (
    <>
      <SegmentPage
        name={TradingLeaderboardEvent.LeagueOnboardingView}
        context={{ tier, event_location: 'main_page' }}
      />
      <Modal>
        <Modal.Close onClose={onClose} />
        <Modal.Content css={vstack.raw({ gap: 16 })}>
          <TierIcon tier={tier} />
          <div>
            <p
              className={css({
                textStyle: 'Text/M/Strong',
                color: 'content.accent.info',
                textAlign: 'center',
              })}
            >
              First trade completed
            </p>
            <p
              className={css({
                textStyle: 'Title/M',
                textAlign: 'center',
                color: 'content.default.level-5',
                whiteSpace: 'pre-wrap',
              })}
            >
              {`Welcome to\nthe ${tierLabel} League`}
            </p>
          </div>
          <p
            className={css({
              textStyle: 'Text/M/Regular',
              color: 'content.default.level-3',
              textAlign: 'center',
            })}
          >
            View your rank and rise with every trade.
          </p>
        </Modal.Content>
        <Modal.Footer>
          <Button
            size='large'
            label='View my rank'
            onClick={() => {
              segment.track(TradingLeaderboardEvent.LeagueOnboardingClick, {
                tier,
                event_location: 'main_page',
              });
              router.push(`/trading-leaderboard?tier=${tier}&interval=WEEKLY`);
              block('TIERED_LEAGUE_DESCRIPTION');
              onClose();
            }}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};
